define("shared/components/shared/post/secondary/caption-writer/list", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/object", "@glimmer/component", "ember-concurrency", "tracked-built-ins", "later/models/generated-caption"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _object, _component2, _emberConcurrency, _trackedBuiltIns, _generatedCaption) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _createCaptionGroup, _addCaptionToGroup, _getCaptionGroupKey, _getCaptionGroupTopicAndTone, _shouldDisplayCaption;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"ember-concurrency",0,"tracked-built-ins",0,"later/models/generated-caption"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    data-test-id="generated-captions-list"
    {{did-insert this.onInsertOrUpdateCaptions}}
    {{did-update this.onInsertOrUpdateCaptions this.generatedCaptions @displayedCaptionIds}}
  >
    {{#each this.captionGroups as |captionGroup|}}
      {{#let (get this.minimizedGroupMap captionGroup.generationId) as |isMinimized|}}
        <Shared::Post::Secondary::CaptionWriter::ListItemGroup
          @generatedCaptionMap={{captionGroup.captions}}
          @isMinimized={{isMinimized}}
          @tone={{captionGroup.tone}}
          @topic={{captionGroup.topic}}
        >
          <:expandToggle>
            <Shared::Ui::Button
              @class="u--p__0"
              @onClick={{fn this.onClickMinimizeToggle captionGroup}}
              @variant="unstyled"
            >
              {{svg-jar (if isMinimized "add" "minus") class="o--icon"}}
            </Shared::Ui::Button>
          </:expandToggle>
  
          <:listItem as |caption|>
            <Shared::Post::Secondary::CaptionWriter::ListItem
              @defaultSegmentAttributes={{@defaultSegmentAttributes}}
              @generatedCaption={{caption}}
              @groupTone={{captionGroup.tone}}
              @hideGeneratedCaption={{@hideGeneratedCaption}}
              @isChangingToneOfCaption={{@isChangingToneOfCaption}}
              @mediaItem={{@mediaItem}}
              @onRefinement={{perform @onCaptionRefinement}}
              @post={{@post}}
              @postElementId={{@postElementId}}
              @shouldDisplayNoRemainingCaptions={{@shouldDisplayNoRemainingCaptions}}
              @showCreditPurchase={{@showCreditPurchase}}
            />
          </:listItem>
        </Shared::Post::Secondary::CaptionWriter::ListItemGroup>
      {{/let}}
    {{/each}}
  </div>
  */
  {
    "id": "7Ga29Tvw",
    "block": "[[[11,0],[24,\"data-test-id\",\"generated-captions-list\"],[4,[38,0],[[30,0,[\"onInsertOrUpdateCaptions\"]]],null],[4,[38,1],[[30,0,[\"onInsertOrUpdateCaptions\"]],[30,0,[\"generatedCaptions\"]],[30,1]],null],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"captionGroups\"]]],null]],null],null,[[[44,[[28,[37,5],[[30,0,[\"minimizedGroupMap\"]],[30,2,[\"generationId\"]]],null]],[[[1,\"      \"],[8,[39,6],null,[[\"@generatedCaptionMap\",\"@isMinimized\",\"@tone\",\"@topic\"],[[30,2,[\"captions\"]],[30,3],[30,2,[\"tone\"]],[30,2,[\"topic\"]]]],[[\"expandToggle\",\"listItem\"],[[[[1,\"\\n          \"],[8,[39,7],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--p__0\",[28,[37,8],[[30,0,[\"onClickMinimizeToggle\"]],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,9],[[52,[30,3],\"add\",\"minus\"]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]],[[[1,\"\\n          \"],[8,[39,11],null,[[\"@defaultSegmentAttributes\",\"@generatedCaption\",\"@groupTone\",\"@hideGeneratedCaption\",\"@isChangingToneOfCaption\",\"@mediaItem\",\"@onRefinement\",\"@post\",\"@postElementId\",\"@shouldDisplayNoRemainingCaptions\",\"@showCreditPurchase\"],[[30,5],[30,4],[30,2,[\"tone\"]],[30,6],[30,7],[30,8],[28,[37,12],[[30,9]],null],[30,10],[30,11],[30,12],[30,13]]],null],[1,\"\\n        \"]],[4]]]]],[1,\"\\n\"]],[3]]]],[2]],null],[13]],[\"@displayedCaptionIds\",\"captionGroup\",\"isMinimized\",\"caption\",\"@defaultSegmentAttributes\",\"@hideGeneratedCaption\",\"@isChangingToneOfCaption\",\"@mediaItem\",\"@onCaptionRefinement\",\"@post\",\"@postElementId\",\"@shouldDisplayNoRemainingCaptions\",\"@showCreditPurchase\"],false,[\"did-insert\",\"did-update\",\"each\",\"-track-array\",\"let\",\"get\",\"shared/post/secondary/caption-writer/list-item-group\",\"shared/ui/button\",\"fn\",\"svg-jar\",\"if\",\"shared/post/secondary/caption-writer/list-item\",\"perform\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/list.hbs",
    "isStrictMode": false
  });

  let ListComponent = (_class = (_createCaptionGroup = /*#__PURE__*/new WeakSet(), _addCaptionToGroup = /*#__PURE__*/new WeakSet(), _getCaptionGroupKey = /*#__PURE__*/new WeakSet(), _getCaptionGroupTopicAndTone = /*#__PURE__*/new WeakSet(), _shouldDisplayCaption = /*#__PURE__*/new WeakSet(), class ListComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _shouldDisplayCaption);

      _classPrivateMethodInitSpec(this, _getCaptionGroupTopicAndTone);

      _classPrivateMethodInitSpec(this, _getCaptionGroupKey);

      _classPrivateMethodInitSpec(this, _addCaptionToGroup);

      _classPrivateMethodInitSpec(this, _createCaptionGroup);

      _defineProperty(this, "minimizedGroupMap", new _trackedBuiltIns.TrackedObject({}));

      _initializerDefineProperty(this, "captionGroupRecord", _descriptor, this);

      _defineProperty(this, "assignCaptionsToGroups", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.captionGroupRecord = this.generatedCaptions.reduce((acc, generatedCaption) => {
            if (!_classPrivateMethodGet(this, _shouldDisplayCaption, _shouldDisplayCaption2).call(this, generatedCaption)) {
              return acc;
            }

            const key = _classPrivateMethodGet(this, _getCaptionGroupKey, _getCaptionGroupKey2).call(this, generatedCaption);

            if (!acc[key]) {
              acc[key] = _classPrivateMethodGet(this, _createCaptionGroup, _createCaptionGroup2).call(this, generatedCaption);
            } else {
              _classPrivateMethodGet(this, _addCaptionToGroup, _addCaptionToGroup2).call(this, acc[key], generatedCaption);
            }

            return acc;
          }, new _trackedBuiltIns.TrackedObject({}));
        }
      }), {
        restartable: true
      }, "assignCaptionsToGroups", null));
    }

    get generatedCaptions() {
      return this.args.generatedCaptions || [];
    }
    /**
     * Array of caption groups sorted by their creation date (descending).
     */


    get captionGroups() {
      return Object.values(this.captionGroupRecord).sort((a, b) => b.createdAt - a.createdAt);
    }

    onInsertOrUpdateCaptions() {
      void this.assignCaptionsToGroups.perform();
    }

    onClickMinimizeToggle(captionGroup) {
      const key = _classPrivateMethodGet(this, _getCaptionGroupKey, _getCaptionGroupKey2).call(this, captionGroup);

      this.minimizedGroupMap[key] = !this.minimizedGroupMap[key];
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "captionGroupRecord", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedObject({});
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onInsertOrUpdateCaptions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsertOrUpdateCaptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickMinimizeToggle", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickMinimizeToggle"), _class.prototype)), _class);
  _exports.default = ListComponent;

  function _createCaptionGroup2(generatedCaption) {
    const {
      topic,
      tone
    } = _classPrivateMethodGet(this, _getCaptionGroupTopicAndTone, _getCaptionGroupTopicAndTone2).call(this, generatedCaption);

    return {
      topic,
      tone,
      createdAt: generatedCaption.get('createdAt'),
      generationId: generatedCaption.get('generationId'),
      captions: new _trackedBuiltIns.TrackedObject({
        [generatedCaption.id]: generatedCaption
      })
    };
  }

  function _addCaptionToGroup2(captionGroup, generatedCaption) {
    const id = generatedCaption.get('id');
    captionGroup.captions[id] = generatedCaption;
  }

  function _getCaptionGroupKey2(keyable) {
    if (keyable instanceof _generatedCaption.default) {
      const generatedCaption = keyable; // Note: if the caption is a rephrase, we need to find the original caption
      // so we can add it to the right caption group.

      if (generatedCaption.isRephrase) {
        const parent = generatedCaption.parent();

        if (parent) {
          return parent.get('generationId');
        }
      }

      return generatedCaption.get('generationId');
    }

    const captionGroup = keyable;
    return captionGroup.generationId;
  }

  function _getCaptionGroupTopicAndTone2(generatedCaption) {
    if (generatedCaption.isRephrase) {
      return {
        topic: 'Rephrase Caption',
        tone: undefined
      };
    }

    if (generatedCaption.isToneChange) {
      return {
        topic: 'Change Tone',
        tone: generatedCaption.get('tone')
      };
    }

    return {
      topic: generatedCaption.get('topic'),
      tone: generatedCaption.get('tone')
    };
  }

  function _shouldDisplayCaption2(generatedCaption) {
    return this.args.displayedCaptionIds.includes(generatedCaption.get('id'));
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListComponent);
});